import styled from "@emotion/styled";
import {
  GelBoxLayout,
  GelButton,
  GelContainerLite,
  GelDisplay1,
  GelParagraph,
  GelScreenDetectorContext,
} from "@tal-gel/components";
import { getGelTokens } from "@tal-gel/theming";
import ModuleContainer from "components/components/ModuleContainer";
import ScrollMore from "components/components/ScrollMore";
import { useContext, useEffect, useState } from "react";
import { capSpace } from "utils/capSpace";

function HomeHero() {
  const { isLargerThanXsScreen, screen } = useContext(GelScreenDetectorContext);
  const [top, setTop] = useState(0);

  useEffect(() => {
    const element = document.getElementById("video");
    const text = document.getElementById("video-content");

    const y = element.getBoundingClientRect().height - text.getBoundingClientRect().height;

    setTop(y / 2);
  }, []);

  return (
    <ModuleContainer>
      <SVideoContainer id="video">
        <div
          style={{
            backgroundColor: getGelTokens().global.themeColorBackgroundOverlayLight,
            height: "calc(100vh - 56px)",
          }}
        >
          <video
            autoPlay
            muted
            loop
            id="myVideo"
            preload="true"
            poster={process.env.PUBLIC_URL + "/images/hero-placeholder.jpg"}
          >
            <source src={process.env.PUBLIC_URL + "/video/hero.mp4"} type="video/mp4" />
          </video>
        </div>

        <SPanel top={top} id="video-content">
          <GelContainerLite fixed>
            <GelDisplay1
              as="h1"
              inverse
              textAlign="center"
              id={capSpace("Header")}
              marginBottom={getGelTokens().global.sizeBaseX6}
            >
              TAL SpotChecker
            </GelDisplay1>

            <GelParagraph inverse large marginBottom={32} textAlign="center">
                          With two in three Australians diagnosed with skin cancer in their lifetime<sup>1</sup>, it's one of Australia's most common cancers. The good news however is that it is also one of the most easily detectable and preventable.
            </GelParagraph>
            {/* <GelBoxLayout space="auto">
              <GelButton
                large
                primary
                onClick={() =>
                  window.open(
                    "https://www.tal.com.au/about-us/our-commitments/our-customers/health/tal-spotchecker/book-a-skin-check",
                    "_blank"
                  )
                }
              >
                Book a skin check
              </GelButton>
            </GelBoxLayout> */}
          </GelContainerLite>
        </SPanel>
        <div
          style={{
            position: "absolute",
            display: "flex",
            width: "100%",
            maxWidth: "100vw",
            bottom: isLargerThanXsScreen(screen) ? 64 : 20,
            justifyContent: "center",
          }}
        >
          <ScrollMore />
        </div>
      </SVideoContainer>
    </ModuleContainer>
  );
}

export default HomeHero;

const SVideoContainer = styled.div({
  width: "100%",
  overflow: "hidden",

  "#myVideo": {
    position: "relative",
    right: 0,
    bottom: 0,
    minWidth: "100%",
    minHeight: "100%",
    zIndex: -1,
    filter: `blur(4px)`,
    scale: "110%",
  },

  "#myVideo::before": {
    content: "''",
    position: "absolute",
    top: 0,
    bottom: 0,
    width: "100%",
  },
});

const SPanel = styled.div(
  {
    opacity: `${({ ratio }) => ratio || 1}`,
    position: "absolute",
    width: "100%",
  },

  (props) => ({
    top: props.top ? props.top : "20%",
  })
);
